import React from 'react'
import KycButton from '../Button/Button'
import '../../kyc/kycStyle.css'
const NewButton = ({ handleAction }) => {
  return (
    <div
      className="footer-btns"
      style={{ display: 'flex', justifyContent: 'left' }}
    >
      <KycButton
        onClick={handleAction}
        variant={'outline-primary'}
        children={'New Search'}
        size="lg"
      />
    </div>
  )
}

export default NewButton
